import ComponentManager from '@/Management/ComponentManager';
import ViewViewModel from '@/ViewModels/ViewViewModel';
import WindowViewModelType from '@/ViewModels/Controls/WindowViewModel';
import LabelViewModelBuilder from '@/Builder/LabelViewModelBuilder';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import * as CoreFrameDTOs from "coreframetypings/dto";
import { default as Loader } from '@/Utility/Loader';

export default class ChangelogPopupViewModel extends ViewViewModel {

    private WindowViewModel = ComponentManager.getViewModel<typeof WindowViewModelType>('WindowViewModel');

    private readonly pdoId: string;
    private readonly pdTypeName: string;
    private readonly window: WindowViewModelType;
    private readonly comments: KnockoutObservable<string[][]>;
    private readonly itOperator: CoreFrameDTOs.IPDIteratorOperatorDTO;

    public constructor(params: any) {
        super(params);

        this.pdoId = this.paramOrDefault(params.pdoId, '-1');
        this.pdTypeName = this.paramOrDefault(params.pdTypeName, '');
        this.itOperator = this.paramOrDefault(params.itOperator, {});
        this.comments = this.observableOrDefault([]);
        this.window = this.createWindow();
        this.loadComments();
    }

    private createWindow(): WindowViewModelType {
        return new this.WindowViewModel({
            isOpen: false,
            width: 600,
            maxHeight: 600,
            isModal: true,
            allowClose: true,
            headline: new LabelViewModelBuilder().withErgName('RAD.RADFOUNDATION.PROBLEMDOMAIN.PERSISTENTOBJECT_CHANGELOGS_ERGNAME').build()
        });
    }

    private loadComments(): void {
        Loader.getInstance().show();
        RADEnvironmentProxy.getInstance().createIteratorForAssoziation({
            pdTypeName: this.pdTypeName,
            pdo_id: this.pdoId,
            assoziationName: 'Changelogs',
            properties: ['Comment.Value', 'Timestamp', 'User'],
            filter: '',
            retrieveExtentCount: true,
            itOperator: this.itOperator,
            orderby: 'this.Changelogs.PDO_Created DESC',
        }).then((iterator) => {
            if (!this.validateStatus(iterator))
                return null;

            return RADEnvironmentProxy.getInstance().getExtent({
                iteratorID: iterator.id,
                start: 0,
                end: parseInt(iterator.extentCount) - 1
            });
        }).then((result) => {
            if (!this.validateStatus(result))
                return null;

            this.comments(result);
            this.window.isOpen(true);
        }).always(() => {
            Loader.getInstance().hide();
        });
    }

}

ComponentManager.setViewModel('ChangelogPopup', ChangelogPopupViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');